import { integrationsApi } from '../../../../../../shared/api';
import { teamsModel } from '../../../../../../features/teams';
import { call, put, select } from 'redux-saga/effects';
import { refreshTeamsData } from '../../../../../../features/teams/model/sagas';
import {
  snackbarModel,
  createNotification,
} from '../../../../../../features/snackbar';
import { integrationsModel } from '../../..';

export function* revokeHubspotToken() {
  const { id: teamId } = yield select(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  yield put(integrationsModel.actions.setIsDisconnectingFromHubspot(true));

  try {
    yield call(integrationsApi.revokeHubspotAccessToken, {
      teamId,
    });

    yield call(refreshTeamsData);

    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('success', 'Successfully disconnected from HubSpot')
      )
    );
  } catch (error) {
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Failed to disconnect from HubSpot')
      )
    );
  } finally {
    yield put(integrationsModel.actions.setIsDisconnectingFromHubspot(false));
  }
}
